import React from 'react';
import { MailIcon, MapPinIcon, MessageSquareIcon, PhoneIcon } from 'lucide-react';
import { ButtonLink } from './ButtonLink';
import { EmbedForm, FormField } from './EmbedForm';
import { business, hours } from '../data/site';
const contactFields: FormField[] = [{
  name: 'name',
  label: 'Name',
  type: 'text',
  required: true,
  autoComplete: 'name'
}, {
  name: 'phone',
  label: 'Phone',
  type: 'tel',
  required: true,
  autoComplete: 'tel'
}, {
  name: 'email',
  label: 'Email',
  type: 'email',
  autoComplete: 'email',
  full: true
}, {
  name: 'message',
  label: 'Message',
  type: 'textarea'
}];
export function Contact() {
  return <section id="contact" aria-labelledby="contact-title" className="gutter section-y w-full scroll-mt-24 bg-navy" data-id="element-50" data-mp="3k44m4r6prcjm">
      <div className="grid gap-12 lg:grid-cols-[1.1fr_1fr] lg:gap-[6vw]" data-id="element-51" data-mp="3f62wtoip2gzp">
        <div data-id="element-52" data-mp="gh4dva727rje">
          <h2 id="contact-title" className="display text-[clamp(3.25rem,8vw,9.5rem)] font-extrabold text-white" data-id="element-53" data-mp="ghw0hvioiexj">
            Call, Text or Stop By.
          </h2>
          <a href={business.tel} className="display mt-8 inline-block text-[clamp(2.5rem,5vw,5rem)] font-bold text-water-300 transition-colors duration-150 hover:text-white" data-id="element-54" data-mp="3jvb7qonzwbcj">
            {business.phone}
          </a>
          <div className="mt-6 flex flex-col gap-3 sm:flex-row" data-id="element-55" data-mp="3b16mckrmrs4e">
            <ButtonLink href={business.tel} variant="water" data-id="element-56" data-mp="3f3jrp82gto0n">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-57" data-mp="315d0ubvxooah" />
              Call Now
            </ButtonLink>
            <ButtonLink href={business.sms} variant="outlineLight" data-id="element-58" data-mp="364g882zdz6lm">
              <MessageSquareIcon className="h-4 w-4" aria-hidden="true" data-id="element-59" data-mp="2s4ev9p5uk8ps" />
              Text Us
            </ButtonLink>
          </div>

          <div className="mt-12 grid gap-8 border-t border-white/15 pt-10 sm:grid-cols-2" data-id="element-60" data-mp="2w58lwqaoc1md">
            <div className="space-y-4 text-white/85" data-id="element-61" data-mp="qcscuc00tm4x">
              <a href={`mailto:${business.email}`} className="flex items-start gap-3 hover:text-white" data-id="element-62" data-mp="qaxo0mlmp9vk">
                <MailIcon className="mt-1 h-5 w-5 shrink-0 text-water-300" aria-hidden="true" data-id="element-63" data-mp="ucay58vr7z8a" />
                <span className="break-all" data-id="element-64" data-mp="239hj1qularvy">{business.email}</span>
              </a>
              <a href={business.directions} target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 hover:text-white" data-id="element-65" data-mp="1yb681csk6bc5">
                <MapPinIcon className="mt-1 h-5 w-5 shrink-0 text-water-300" aria-hidden="true" data-id="element-66" data-mp="1pc2ns5hnnpw2" />
                <span data-id="element-67" data-mp="2m1tr8u7xcne0">
                  {business.street}
                  <br data-id="element-68" data-mp="2m1a8jbag9uyx" />
                  {business.city}, {business.state} {business.zip}
                </span>
              </a>
            </div>
            <dl className="space-y-2" data-id="element-69" data-mp="2d98atkrrmssc">
              {hours.map(h => <div key={h.day} className="flex justify-between gap-4 border-b border-white/10 pb-2 text-white/85" data-id="element-70" data-mp="28aoohj99fezg">
                  <dt className="font-semibold text-white" data-id="element-71" data-mp="35psvrnbwayaz">{h.day}</dt>
                  <dd data-id="element-72" data-mp="35rvssrbgtrp7">{h.time}</dd>
                </div>)}
            </dl>
          </div>
          <p className="mt-8 max-w-[56ch] text-white/75" data-id="element-73" data-mp="30xhqs62asmbk">
            <strong className="font-semibold text-white" data-id="element-74" data-mp="38bsejxla0fam">After hours? Call anyway.</strong> Our phone assistant takes your details and Michael
            gets back to you first thing.
          </p>
        </div>

        <div className="lg:pt-4" data-id="element-75" data-mp="3i73n1y63cq9x">
          <EmbedForm embedId="onedash-form-contact" fields={contactFields} submitLabel="Send Message" successTitle="Message sent" successText="Thanks for reaching out. Michael will get back to you soon." data-id="element-76" data-mp="3ma9yrlbz39ns" />
        </div>
      </div>
    </section>;
}